function getRequestHeader(request, key) {
  return request.headers.get(key);
}
export {
  getRequestHeader
};
